<template>
  <Transition name="banner-slide">
    <div v-if="show" class="continue-banner">
      <div class="continue-banner__content">
        <div class="continue-banner__icon fs-lg d-none d-md-block">
          <i class="icon icon-package"></i>
        </div>
        <div class="continue-banner__text">
          <span class="d-block fw-medium text-black h6 mb-05"
            >Je hebt een opgeslagen configuratie!</span
          >
          <span v-if="summary" class="d-block fs-sm text-gray-600">
            {{ formatPrice(summary.estimatedPrice) }},
            {{ summary.totalItems }} producten
          </span>
        </div>
        <div class="continue-banner__actions">
          <button @click="handleContinue" class="btn btn--cta">
            Verder configureren
            <i class="icon icon-arrow"></i>
          </button>
          <button @click="handleNew" class="btn btn--gray">
            Start opnieuw
            <i class="icon icon-refresh"></i>
          </button>
          <button
            @click="handleDismiss"
            class="btn btn--icon-sm btn--transparent continue-banner__close d-none d-md-block"
            aria-label="Sluiten"
          >
            <i class="icon icon-close"></i>
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'ContinueBanner',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    summary: {
      type: Object,
      default: null,
    },
  },
  emits: ['continue', 'new', 'dismiss'],
  mounted() {
    if (this.show) {
      this.autoHideTimer = setTimeout(() => {
        this.handleDismiss();
      }, 30000);
    }
  },
  beforeUnmount() {
    if (this.autoHideTimer) {
      clearTimeout(this.autoHideTimer);
    }
  },
  methods: {
    reloadProducts() {
      window.globalProductCache = {};
      document.dispatchEvent(new CustomEvent('s7_reload_products'));
    },
    handleContinue() {
      this.$emit('continue');
      this.reloadProducts();
      this.handleDismiss();
    },
    handleNew() {
      this.$emit('new');
      this.reloadProducts();
      this.handleDismiss();
    },
    handleDismiss() {
      if (this.autoHideTimer) {
        clearTimeout(this.autoHideTimer);
        this.autoHideTimer = null;
      }
      this.$emit('dismiss');
    },
    formatPrice(price) {
      if (!price) return '€0,00';
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      }).format(price);
    },
  },
};
</script>
